import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/images': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M480 416v16c0 26.5-21.5 48-48 48h-384c-26.5 0-48-21.5-48-48v-256c0-26.5 21.5-48 48-48h16v48h-10c-3.3 0-6 2.7-6 6v244c0 3.3 2.7 6 6 6h372c3.3 0 6-2.7 6-6v-10h48zM522 80h-372c-3.3 0-6 2.7-6 6v244c0 3.3 2.7 6 6 6h372c3.3 0 6-2.7 6-6v-244c0-3.3-2.7-6-6-6zM528 32c26.5 0 48 21.5 48 48v256c0 26.5-21.5 48-48 48h-384c-26.5 0-48-21.5-48-48v-256c0-26.5 21.5-48 48-48h384zM264 144c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40 40 17.9 40 40zM192 240l39.5-39.5c4.7-4.7 12.3-4.7 17 0l39.5 39.5 103.5-103.5c4.7-4.7 12.3-4.7 17 0l71.5 71.5v80h-288v-48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/images.js
// module id = 1782
// module chunks = 0